import { CustomerFullInformation } from '../../customer/models/customer-information.model';
import { Pagination } from '../../../shared/models/app.model';
import { InvoiceStatus } from '../../expense/models/expense.model';

export interface CheckOPDList extends Pagination {
  content: CheckOPD[];
}

export interface CheckOPD {
  docNo: string;
  customerName: string;
  status: OPDStatus;
  invoiceStatus: InvoiceStatus;
  created: number;
  updated: number;
}

export interface VitalSignDoc {
  docNo: string;
  mcDocNo: string;
  created: number;
  mcCreated: number;
  icd: ICD[];
}

export interface VitalSign {
  docNo: string;
  weight: number;
  height: number;
  bmi?: number;
  temp?: number;
  bpSys?: string;
  pr?: number;
  bpDia?: number;
  alcohol?: number;
  smoke?: number;
  certificate?: boolean;
  restDateFrom?: number;
  restDateTo?: number;
  icd: { code: string; name: string }[];
  cc?: string;
  hpi?: string;
  pmh?: string;
  dx?: string;
  ga?: string;
  pe?: string;
}

export interface Program {
  id: string;
  name: string;
  drugAdministration?: string;
  properties?: string;
  amount?: number;
  unitId: string;
  unitName: string;
  price?: number;
  stock?: number;
  discount?: number;
  total?: number;
}

export interface OPD {
  docNo?: string;
  created?: number;
  customerFullInformation: CustomerFullInformation;
  status: OPDStatus;
  invoiceStatus?: InvoiceStatus;
  programs: Program[];
  vitalSigns: VitalSignDoc[];
}

export interface ICD {
  code: string;
  name: string;
}

export enum OPDStatus {
  WAITING_FOR_EXAMINING = 'WAITING_FOR_EXAMINING',
  EXAMINING = 'EXAMINING',
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  COMPLETE = 'COMPLETE',
  CANCEL = 'CANCEL'
}

export const CheckOPDOptions = [
  {
    key: OPDStatus.WAITING_FOR_EXAMINING,
    value: OPDStatus.WAITING_FOR_EXAMINING
  },
  {
    key: OPDStatus.EXAMINING,
    value: OPDStatus.EXAMINING
  },
  {
    key: OPDStatus.WAITING_FOR_PAYMENT,
    value: OPDStatus.WAITING_FOR_PAYMENT
  },
  {
    key: OPDStatus.COMPLETE,
    value: OPDStatus.COMPLETE
  },
  {
    key: OPDStatus.CANCEL,
    value: OPDStatus.CANCEL
  }
];
